import {Component, ViewEncapsulation} from '@angular/core';
import {Subscription} from "rxjs";
import {AuthService} from "./auth/auth.service";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {animate, query, style, transition, trigger} from "@angular/animations";

export const showAnimation = trigger(
  'showAnimation',
  [
    transition(
      ':enter',
      [
        style({opacity: 0}),
        animate('0.5s ease',
          style({opacity: 1}))
      ]
    ),
    transition(
      ':leave',
      [
        style({opacity: 1}),
        animate('0.5s ease',
          style({opacity: 0}))
      ]
    )
  ]
);

export const listAnimation = trigger('listAnimation',
  [
    transition('* <=> *',
      [
        // query(':enter',
        //   [
        //     style({opacity: 0}),
        //     animate('0.5s ease',
        //       style({opacity: 1}))],
        //   {optional: true}
        // ),
        query(':leave',
          [
            style({opacity: 0, width: '*', padding: '*', margin: '*'}),
            animate('0.5s ease',
              style({opacity: 0, width: 0, padding: 0, margin: 0}))],
          {optional: true}
        )
      ])
  ]);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  title = 'Vallourec Upload';
  // @ts-ignore
  authenticationSubscription: Subscription;
  // @ts-ignore
  authorizationSubscription: Subscription;
  // @ts-ignore
  internalSubscription: Subscription;
  // @ts-ignore
  public loggedIn: boolean;
  // @ts-ignore
  public authorized: boolean;
  // @ts-ignore
  public internal: boolean;

  constructor(
    public auth: AuthService,
    private router: Router
  ) {
    router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    )
      .subscribe(event => {
        const navigation: any = event
        this.activeLinkSwitch(navigation.url)
      });
  }

  ngOnInit() {
    this.authenticationSubscription = this.auth.isAuthenticated()
      .subscribe(result => {
        this.loggedIn = result;
      });
    this.authorizationSubscription = this.auth.isAuthorized()
      .subscribe(result => {
        this.authorized = result;
        if (!this.authorized) this.activeLink = "Download"
      });
    this.internalSubscription = this.auth.isInternal()
      .subscribe(result => {
        this.internal = result;
        if (!this.internal) this.activeLink = "Download"
      });
  }

  ngOnDestroy() {
    this.authenticationSubscription.unsubscribe();
    this.authorizationSubscription.unsubscribe();
    this.internalSubscription.unsubscribe();
  }

  links = [
    { name: 'Share', link: 'upload', icon: 'cloud_upload' },
    { name: 'Download', link: 'download', icon: 'cloud_download' },
    { name: 'Authorize', link: 'authorize', icon: 'admin_panel_settings' },
    { name: 'Translate', link: 'translate', icon: 'translate' }
  ];
  activeLink = this.links[0].name;

  activeLinkSwitch(url: string) {
    switch (url) {
      case '/upload': {
        this.activeLink = this.links[0].name;
        break;
      }
      case '/download': {
        this.activeLink = this.links[1].name;
        break;
      }
      case '/authorize': {
        this.activeLink = this.links[2].name;
        break;
      }
      case '/translate': {
        this.activeLink = this.links[3].name;
        break;
      }
    }
  }

  onNavigate(): void {
    this.activeLinkSwitch(this.router.url)
  }
}
